module.exports = __webpack_public_path__ + "img/img_event_01.14ae8b89.svg";